/* eslint-disable react/no-unescaped-entities */
import React, { ReactNode } from "react";
import { inviteEmailSchema, inviteEmailType } from "ps-shared";
import Checkbox from "src/components/Forms/FormikCheckbox";
import { Formik, Field, ErrorMessage } from "formik";
import ReactGA from "react-ga";
import { Button, Col, Form, FormGroup, Row, Label } from "reactstrap";
import { CognitoSession } from "src/models/CognitoSession";
import { AdminService } from "src/services/AdminService";

interface InviteFormProps {
  cb: (data: InviteFormCb) => void;
  session?: CognitoSession;
}
export interface InviteFormCb {
  success: boolean;
}
export const InviteForm: React.FunctionComponent<InviteFormProps> = (props: InviteFormProps) => {
  const [submitted, setSubmitted] = React.useState(false);
  const [errored, setErrored] = React.useState(false);
  const [charCount, setCharCount] = React.useState(null);
  const maxChars = 250;
  const updateCharCount = (e: any): void => {
    const chars = e ? e.length : 0;
    setCharCount(chars > 0 ? maxChars - chars : maxChars);
  };
  const personalMsg =
    "Psychedelic Support is definitely worth checking out. It’s free to join and an excellent resource.";
  React.useEffect(() => {
    // update
    updateCharCount(personalMsg);
  }, []);
  const formValues = inviteEmailSchema.cast() as {
    inviteeEmail: string;
    inviteeFirstName: string;
    inviteeLastName: string;
    personalMsg: string;
    includeMsg: boolean;
  };
  formValues.personalMsg = personalMsg;
  formValues.includeMsg = true;

  return (
    <div className="profile-section">
      {submitted && <div>Thank you for the recommendation of our service!</div>}
      {!submitted && (
        <Formik
          initialValues={formValues}
          validationSchema={inviteEmailSchema}
          enableReinitialize={false}
          onSubmit={async (values, { setSubmitting }): Promise<void> => {
            setErrored(false);
            if (values.includeMsg === false) {
              values.personalMsg = null;
            }
            setSubmitting(true);
            try {
              await AdminService.invite(values as inviteEmailType);
              ReactGA.event({
                category: "profile",
                action: "invite",
                label: props.session.username,
              });
              setSubmitted(true);
            } catch (error) {
              console.error(error);
              setErrored(true);
              props.cb({ success: false } as InviteFormCb);
              setSubmitting(false);
            }
          }}
        >
          {(formik): ReactNode => (
            <>
              <Row>
                <Col>
                  We’re grateful you consider our service valuable. Please fill out this form to invite your friends to
                  join the network or list a community group!
                </Col>
              </Row>
              <Row className="mt-5">
                <Col xs="12">
                  <Form role="form" className="profile-contact" onSubmit={formik.handleSubmit}>
                    <FormGroup className="mb-3">
                      <Label for="name">Friend's First Name:</Label>
                      <br />
                      <Field
                        placeholder="First Name"
                        type="text"
                        component="input"
                        name="inviteeFirstName"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="inviteeFirstName"
                        component="div"
                        className="position-relative form-feedback"
                      />
                    </FormGroup>
                    <FormGroup className="mb-3">
                      <Label for="name">Friend's Last Name:</Label>
                      <br />
                      <Field
                        placeholder="Last Name"
                        type="text"
                        component="input"
                        name="inviteeLastName"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="inviteeLastName"
                        component="div"
                        className="position-relative form-feedback"
                      />
                    </FormGroup>
                    <FormGroup className="mb-3">
                      <Label for="name">Friend's Email:</Label>
                      <br />
                      <Field
                        placeholder="email"
                        type="text"
                        component="input"
                        name="inviteeEmail"
                        onChange={formik.handleChange}
                        className="form-control"
                      />
                      <ErrorMessage name="inviteeEmail" component="div" className="position-relative form-feedback" />
                    </FormGroup>
                    <FormGroup>
                      <Checkbox name="includeMsg" value={true} label="I'd like to include a personal message" />
                    </FormGroup>
                    {formik.values.includeMsg === true && (
                      <FormGroup>
                        <Label for="personalMsg">Personal Message:</Label>
                        <br />
                        <Field
                          type="text"
                          component="textarea"
                          name="personalMsg"
                          className="form-control"
                          maxLength={maxChars}
                          onKeyUp={(e): void => updateCharCount(e.target.value)}
                        />
                        <div className="help-text">{charCount} characters remaining</div>
                        <ErrorMessage name="personalMsg" component="div" className="form-feedback" />
                      </FormGroup>
                    )}

                    <div className="text-center">
                      {errored && (
                        <FormGroup>
                          <div className="form-feedback">
                            There was an error submitting your request, please try again!
                          </div>
                        </FormGroup>
                      )}
                      <Button className="my-4" color="primary" type="submit" disabled={formik.isSubmitting}>
                        Submit
                      </Button>
                    </div>
                  </Form>
                </Col>
              </Row>
            </>
          )}
        </Formik>
      )}
    </div>
  );
};
